import React from 'react';
import { connect } from 'react-redux';
import ReactTooltip from "react-tooltip";
import jsPDF from "jspdf";

import { SERVER_URL } from "../../constants/constants.js";

import { Mixpanel } from "../../helpers";


function DownloadPage(props) {

    const { currentPage, authentication, org } = props;
    const current_token = authentication.jwt;
    const iconDownloadPage = require("../../images/download-page.svg");

    const org_id = org?.current_org_id;
    const user_id = authentication?.user?.user_id;
    const page_id = currentPage?.page_id;

    const constructPageUrl = (item) => {
        return (
          SERVER_URL +
          "/org/" +
          org.current_org_id +
          "/dealjacket/" +
          item.deal_jacket_id +
          "/page/" +
          item.page_id +
          "/download" +
          "?token=" +
          current_token
        );
      };

    const constructPdfName = () => {
        return currentPage.page_id + '.pdf';
    }

      // The dimensions are in millimeters.
const A4_PAPER_DIMENSIONS = {
    width: 210,
    height: 297,
  };

  const A4_PAPER_RATIO = A4_PAPER_DIMENSIONS.width / A4_PAPER_DIMENSIONS.height;

  // Calculates the best possible position of an image on the A4 paper format,
  // so that the maximal area of A4 is used and the image ratio is preserved.
  const imageDimensionsOnA4 = (dimensions) => {
    const isLandscapeImage = dimensions.width >= dimensions.height;

    // If the image is in landscape, the full width of A4 is used.
    if (isLandscapeImage) {
      return {
        width: A4_PAPER_DIMENSIONS.width,
        height:
          A4_PAPER_DIMENSIONS.width / (dimensions.width / dimensions.height),
      };
    }

    // If the image is in portrait and the full height of A4 would skew
    // the image ratio, we scale the image dimensions.
    const imageRatio = dimensions.width / dimensions.height;
    if (imageRatio > A4_PAPER_RATIO) {
      const imageScaleFactor =
        (A4_PAPER_RATIO * dimensions.height) / dimensions.width;

      const scaledImageHeight = A4_PAPER_DIMENSIONS.height * imageScaleFactor;

      return {
        height: scaledImageHeight,
        width: scaledImageHeight * imageRatio,
      };
    }

    // The full height of A4 can be used without skewing the image ratio.
    return {
      width: A4_PAPER_DIMENSIONS.height / (dimensions.height / dimensions.width),
      height: A4_PAPER_DIMENSIONS.height,
    };
  };



// Creates a PDF document containing all the uploaded images.
const generatePdfFromImage = (image) => {

    // Default export is A4 paper, portrait, using millimeters for units.
    const doc = new jsPDF();

    // We let the images add all pages,
    // therefore the first default page can be removed.
    doc.deletePage(1);

      const imageDimensions = imageDimensionsOnA4({
        width: image.width,
        height: image.height,
      });

      doc.addPage();
      doc.addImage(
        image.src,
        'png',
        // Images are vertically and horizontally centered on the page.
        (A4_PAPER_DIMENSIONS.width - imageDimensions.width) / 2,
        (A4_PAPER_DIMENSIONS.height - imageDimensions.height) / 2,
        imageDimensions.width,
        imageDimensions.height
      );


    // Creates a PDF and opens it in a new browser tab.
        doc.setProperties({ title: currentPage.page_id+'.pdf'});

    const pdfURL = doc.output("bloburl");
    window.open(pdfURL, constructPdfName());

  };



  const handleGeneratePdfFromImage = () => {

    const custom_properties = {
      'tt_user_id': user_id,
      'tt_org_id': org_id,
      'tt_page_id': page_id
    };
     Mixpanel.track('ViewPagePdfFromCarousel', custom_properties);  


    var img = new Image();

    img.src = constructPageUrl(currentPage);
    img.crossOrigin = "anonymous";  // This enables CORS

    img.onload = function() {

        generatePdfFromImage(img);
    }
  }


    return (
        <>

            <span
                data-tip
                data-for={"Download Image"}
                className="carouselAction"
            >
            <img
                className="carouselActionImage"
                src={iconDownloadPage}
                alt="Download"
                onClick={handleGeneratePdfFromImage}
            />
            </span>
            <ReactTooltip
                id={"Download Image"}
                place="bottom"
                effect="solid"
                data-type="info"
                delayShow={200}
            >
                Open Page in New Window
            </ReactTooltip>
        </>

    );

};

function mapStateToProps(state) {
    const { authentication, org } = state;
    return {
      authentication,
      org
    };
  }


  const connectedDownloadPage = connect(
    mapStateToProps
  )(DownloadPage);
  export { connectedDownloadPage as DownloadPage };
